<template>
	<div class="equipment clearfix">
		<div class="equbody_father">
			<div class="overAutoBasic">
				<el-collapse v-model="activeNamesBasic">
					<el-collapse-item :title="item.name" v-for='(item,index) in BasicControls' :name="index" class="equbody clearfix" :key="index">
						<div class="equbody_content clearfix" :name="item.name">
							<div v-for='(itemChildren,index) in item.children' v-show="itemChildren.mapType==mapType||itemChildren.mapType==3" :title="itemChildren.name" :data-name="item.name" :data-name-id='item.id' :data-content-id='itemChildren.id' :data-content-name='itemChildren.name' :style="{'background-image': 'url('+itemChildren.image+')'}" ondragstart="return false;" class="equbody_content_box backgroundDiv clearfix">
								<div class="equbody_content_box_name" :data-name="item.name" :data-name-id='item.id' :data-content-name='itemChildren.name' :data-content-id='itemChildren.id'>
									{{ itemChildren.name }}
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>
			<div class="bottomHeader">
				扩展控件
			</div>
			<div class="overAuto">
				<el-collapse v-model="activeNames">
					<el-collapse-item :title="item.name" v-for='(item,index) in mothFather' :name="index" class="equbody clearfix" :key="index">
						<div class="equbody_content clearfix" :name="item.name">
							<div v-for='(itemChildren,index) in item.children' :ref="item.name+item.id" :title="itemChildren.name" :data-name="item.name" :data-name-id='item.id' :data-content-id='itemChildren.id' :data-content-name='itemChildren.name' :style="{'background-image': 'url('+ImageBaseUrl+itemChildren.image+')'}" ondragstart="return false;" class="backgroundSizeControl equbody_content_box clearfix" :key="index">
								<div class="equbody_content_box_name" :data-name="item.name" :data-name-id='item.id' :data-content-name='itemChildren.name' :data-content-id='itemChildren.id'>
									{{ itemChildren.name }}
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import { mapState } from 'vuex';
	import { mapActions } from 'vuex';
	import { mapMutations } from 'vuex';
	export default {
		name: 'Home',
		data() {
			return {
				activeNamesBasic: [0],
				activeNames: [],
        // 6.23添加2d管道  id为 10，11
				BasicControls: [{
					id: 1,
					name: "基本控件",
					ShowMark: true,
					children: [{
						id: 3,
						name: '阀门竖',
            mapType:3,
						image: require('@/assets/image/editor/icon/valveV.png'),
					}, {
						id: 4,
						name: '阀门横',
            mapType:3,
						image: require('@/assets/image/editor/icon/valveH.png'),
					}, {
						id: 1,
						name: '文本标签',
            mapType:3,
						image: require('@/assets/image/editor/icon/label.png'),
					}, {
						id: 7,
						name: 'X轴管道',
            mapType:2,
						image: require('@/assets/image/editor/icon/ConduitH.png'),
					}, {
						id: 8,
						name: 'Y轴管道',
            mapType:2,
						image: require('@/assets/image/editor/icon/ConduitV.png'),
					}, {
						id: 9,
						name: 'Z轴管道',
            mapType:2,
						image: require('@/assets/image/editor/icon/ConduitZ.png'),
					},  {
						id: 10,
						name: 'Y轴管道-2D',
            mapType:1,
						image: require('@/assets/image/editor/icon/ConduitY_2d.png'),
					}, {
						id: 11,
						name: 'X轴管道-2D',
            mapType:1,
						image: require('@/assets/image/editor/icon/ConduitZ_2d.png'),
					},{
						id: 2,
						name: '属性看板',
            mapType:3,
						image: require('@/assets/image/editor/icon/board.png'),
					}, {
						id: 5,
						name: '仪表竖',
            mapType:3,
						image: require('@/assets/image/editor/icon/meterV.png'),
					}, {
						id: 6,
						name: '仪表横',
            mapType:3,
						image: require('@/assets/image/editor/icon/meterH.png'),
					}]
				}],

				//设备分类数组
				mothFather: [],
				//设备列表分类总数组
				moth: [],
				//设备列表
				tableData: [],

			}
		},
		computed: {
			...mapState("defaultImgOptions", {
				draggable: 'draggable',
				defaultOptions: 'defaultOptions',
				ImageBaseUrl: 'ImageBaseUrl',
				defaultDeviceConfig: 'defaultDeviceConfig',
				defaultBasicConfig: 'defaultBasicConfig'
			}),
			companyId() {
				return this.$store.state.companyId;
			},
		},
    props:{
      mapType:{
        type:Number,
        default:2
      }
    },
		mounted() {
			var self = this;
			/*调用控件列表接口 */
			self.get('/Control/getList', {}).then((res) => {
				if(res.success == true) {
					//this.ArrayClassify(res.result)
					self.tableData = res.result
					/*获取字典分类*/
					self.get('/Dict/getListByType', {
						type: 4
					}).then((res) => {
						if(res.success == true) {
							self.mothFather = res.result;
							for(var a = 0; a < self.mothFather.length; a++) {
								self.mothFather[a].children = [];
								self.mothFather[a].ShowMark = true;
								for(var i = 0; i < self.tableData.length; i++) {
									if(self.mothFather[a].id == self.tableData[i].categoryId) {
										self.mothFather[a].children.push(self.tableData[i]);
									}
								}
							}
							/*预加载图片*/
							self.loadImage();
						}
					})
				}
			})

		},
		created(){

		},
		methods: {
			...mapMutations("defaultImgOptions", {
				//NowActiveModify: 'NowActiveModify'
				DefaultConfigDeviceUpdata: 'DefaultConfigDeviceUpdata',
				MapUpdata: 'MapUpdata',
				draggableUpdata: 'draggableUpdata',
				scaleLevelModify: 'scaleLevelModify',
        MapBgUpdata:"MapBgUpdata"
			}),
			defaultConfigDevice(){
				//console.log(this.mothFather)
				this.DefaultConfigDeviceUpdata([this.mothFather,this.tableData]);
				/*获取最新设备地图*/
				this.get('/DeviceMap/getCurrent', {
					companyId: this.companyId
				}).then((res) => {
					if(res.success == true) {
						let MapType;
						if(res.result.type == 1) {
							MapType = '历史版本'
						} else if(res.result.type == 2) {
							MapType = '草稿/自动保存'
						}
						this.MapUpdata({
							name: res.result.name,
							type: MapType
						});
						if(!res.result.content){
							this.draggableUpdata([])
							return;
						}
						res.result.content = JSON.parse(res.result.content)
						this.scaleLevelModify(res.result.content.scaleLevel)
            if(res.result.content.mapType){
              this.$emit("setMapType",res.result.content.mapType)
            }
            if(res.result.content.MapBgData){
              this.MapBgUpdata(res.result.content.MapBgData)
            }
						let arr = res.result.content.draggable;
						for(let ThisActive of arr){
							if(ThisActive.colorId == 1) {
								if(ThisActive.rotateDeg == 90) {
									ThisActive.imagePng = require('@/assets/image/editor/gray_top_png.png')
									ThisActive.imageGif = require('@/assets/image/editor/gray_top_gif.gif')
								} else {
									ThisActive.imagePng = require('@/assets/image/editor/gray_png.png')
									ThisActive.imageGif = require('@/assets/image/editor/gray_gif.gif')
								}
							} else if(ThisActive.colorId == 2) {
								if(ThisActive.rotateDeg == 90) {
									ThisActive.imagePng = require('@/assets/image/editor/red_top_png.png')
									ThisActive.imageGif = require('@/assets/image/editor/red_top_gif.gif')
								} else {
									ThisActive.imagePng = require('@/assets/image/editor/red_png.png')
									ThisActive.imageGif = require('@/assets/image/editor/red_gif.gif')
								}
							} else if(ThisActive.colorId == 3) {
								if(ThisActive.rotateDeg == 90) {
									ThisActive.imagePng = require('@/assets/image/editor/blue_top_png.png')
									ThisActive.imageGif = require('@/assets/image/editor/blue_top_gif.gif')
								} else {
									ThisActive.imagePng = require('@/assets/image/editor/blue_png.png')
									ThisActive.imageGif = require('@/assets/image/editor/blue_gif.gif')
								}
							} else if(ThisActive.colorId == 4) {
								if(ThisActive.rotateDeg == 90) {
									ThisActive.imagePng = require('@/assets/image/editor/green_top_png.png')
									ThisActive.imageGif = require('@/assets/image/editor/green_top_gif.gif')
								} else {
									ThisActive.imagePng = require('@/assets/image/editor/green_png.png')
									ThisActive.imageGif = require('@/assets/image/editor/green_gif.gif')
								}
							} else if(ThisActive.colorId == 5) {
								if(ThisActive.rotateDeg == 90) {
									ThisActive.imagePng = require('@/assets/image/editor/org_top_png.png')
									ThisActive.imageGif = require('@/assets/image/editor/org_top_gif.gif')
								} else {
									ThisActive.imagePng = require('@/assets/image/editor/org_png.png')
									ThisActive.imageGif = require('@/assets/image/editor/org_gif.gif')
								}
							}
						}
						this.draggableUpdata(arr)
					}
				})
			},
			loadImage() {
				/*先将所有图片取出放入数组，进行预加载 待预加载结束后再调用默认配置设备方法*/
				let DeviceList = this.mothFather;
				let count = 0;
				let ImgArr = [];
				for(var a = 0; a < DeviceList.length; a++){
					for(var i = 0; i < DeviceList[a].children.length; i++){
						ImgArr.push(this.ImageBaseUrl+DeviceList[a].children[i].image);
					}
				}

				//默认配置设备
				/*this.defaultConfigDevice();
				for(var y = 0; y < this.mothFather.length; y++){
					this.activeNames.push(y)
				}*/
				for(let img of ImgArr) {
					let image = new Image();
					image.src = img;
					image.onload = () => {
						count++;
						if(count == ImgArr.length){
							//默认配置设备
							this.defaultConfigDevice();
							for(var y = 0; y < this.mothFather.length; y++){
								this.activeNames.push(y)
							}
						}
					};
					image.onerror = (error) => {
						count++;
						if(count == ImgArr.length){
							//默认配置设备
							this.defaultConfigDevice();
							for(var y = 0; y < this.mothFather.length; y++){
								this.activeNames.push(y)
							}
						}
					}
				}
			}
		},
	}
</script>
<style scoped>
	.bottomHeader{
		/*background-color: #151515;*/
        height: 48px;
	    line-height: 48px;
	    text-indent: 16px;
	    color: #DADADA !important;
	    border: 0 !important;
	    text-align: left;
	}
	.backgroundSizeControl {
		background-size: 30px;
	}
	.backgroundDiv{
		background-position: center 9px;
		background-repeat: no-repeat;
	}
	.overAutoBasic{
		border-bottom: 1px solid #151515;
	}

	.overAutoBasic>>>.el-collapse-item__wrap {
		border: 0 !important;
		background-color: unset !important;
	}

	.overAutoBasic>>>.el-collapse {
		border-top: 0 !important;
		border-bottom: 1px solid rgba(21, 21, 21, 0) !important;
	}

	.overAutoBasic>>>.el-collapse-item__header {
		background-color: #252626;
		text-indent: 16px;
		color: #DADADA !important;
		border: 0 !important;
		transition: .3s;
	}
	.overAutoBasic>>> .el-collapse-item__header:hover{
		background-color: #151515;
	}
	.overAutoBasic>>>.el-collapse-item__arrow {
		text-indent: 0 !important;
	}

	.overAuto>>>.el-collapse-item__wrap {
		border: 0 !important;
		background-color: unset !important;
	}

	.overAuto>>>.el-collapse {
		border: 0px !important;
	}

	.overAuto>>>.el-collapse-item__header {
		background-color: #252626;
		text-indent: 16px;
		color: #DADADA !important;
		border: 0px !important;
		transition: .3s;
	}

	.overAuto>>>.el-collapse-item__arrow {
		text-indent: 0 !important;
	}

	.overAuto::-webkit-scrollbar {
		width: 10px;
	}

	.overAuto::-webkit-scrollbar-button:start {
		background: url(../../../assets/image/editor/icon/top.png)no-repeat 1px center;
		width: 10px;
		height: 10px;
	}

	.overAuto::-webkit-scrollbar-button:end {
		background: url(../../../assets/image/editor/icon/bottom.png)no-repeat 1px center;
		width: 10px;
		height: 10px;
	}

	.overAuto::-webkit-scrollbar-track {
		background: rgba(32, 33, 34, 1);
		width: 11px;
	}

	.overAuto::-webkit-scrollbar-thumb {
		cursor: pointer;
		background: rgba(119, 120, 120, 1);
		width: 11px;
	}

	.overAuto {
		height: calc(100% - 409px);
		width: 100%;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.tranRotate {
		transform: rotate(90deg) !important;
	}

	.equipment {
		width: 226px;
		height: 100%;
		background-color: #252626;
		position: relative;
		/*z-index: 10;*/
	}

	.equbody_father {
		/*padding-top: 10px;*/
	    height: 100%;
    	width: 100%;
	}

	.equbody {
		width: 226px;
		/* height: auto; */
		/*padding-left: 16px;
		margin-bottom: 15px;
		margin-top: 18px;*/
	}

	.equbody .equbody_title {
		width: calc(100% - 16px);
		height: auto;
		color: #DADADA;
		font-size: 14px;
		/* border-bottom: 2px solid #2C92F6; */
		text-align: left;
		letter-spacing: 0.5px;
		/* margin-bottom: 10px; */
		float: left;
		line-height: 50px;
		padding-left: 16px;
		position: relative;
		/*background: url(../../../assets/image/editor/icon/deviceBottomMark.png)no-repeat;
	    background-position: 95% center;*/
		background-color: #252626;
		cursor: pointer;
	}
	.overAuto>>> .el-collapse-item__header:hover{
		background-color: #151515;
	}
	.equbody .equbody_title:hover {
		background-color: #151515;
	}

	.equbody .equbody_title img {
		position: absolute;
		/*right: 8px;*/
		top: 0;
		bottom: 0;
		margin: auto;
		transform-origin: 50% 50%;
		transition: .3s;
		transform: rotate(0deg);
		margin-left: 10px;
	}

	.equbody .equbody_content {
		width: calc(100% - 16px);
		height: auto;
		color: #fff;
		font-size: 12px;
		float: left;
		/* padding-bottom: 18px; */
		/* padding-top: 14px; */
		padding-left: 16px;
		transition: .3s;
		overflow: hidden;
	}

	.equbody .equbody_content .equbody_content_box {
		text-align: center;
    	float: left;
	    margin-right: 10px;
	    margin-bottom: 30px;
	    margin-top: 1px;
	    cursor: pointer;
	    width: 53px;
	    height: 53px;
	    border: 1px solid rgba(112, 112, 112, .8);
	    background-repeat: no-repeat;
	    background-position: center;
	    /* transition: .1s; */
	    position: relative;
	}

	.equbody .equbody_content .equbody_content_box:hover {
		border: 1px solid rgba(37, 113, 239, 1) !important;
		outline: 1px solid rgba(37, 113, 239, 1);
	}

	.equbody .equbody_content .equbody_content_box_img {
		width: 100%;
		text-align: center;
		float: left;
	}

	.equbody .equbody_content .equbody_content_box_img img {
		/*width: 40px;*/
		/*height: 40px;*/
	}

	.equbody .equbody_content .equbody_content_box_name {
		width: 100%;
	    display: inline-block;
	    overflow: hidden;
	    text-overflow: ellipsis;
	    white-space: nowrap;
	    color: #DADADA;
	    /* float: left; */
	    margin-top: 32px;
	    font-size: 12px;
	    transform: scale(0.95);
	    position: absolute;
	    left: 0;
	    right: 0;
	    bottom: -30px;
	    line-height: 30px;
	}
	* {
		-webkit-touch-callout: none;
		/*系统默认菜单被禁用*/
		-webkit-user-select: none;
		/*webkit浏览器*/
		-khtml-user-select: none;
		/*早期浏览器*/
		-moz-user-select: none;
		/*火狐*/
		-ms-user-select: none;
		/*IE10*/
		user-select: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/MapEditor/equipment/equipment.vue